import { BrokerSettingsFields, BrokerField } from './broker.interface';
import { BrokerSettingKeyType } from './broker.enums';

export class ParsedBrokerField {
    name: string;
    type: 'text' | 'number';
    isPassword: boolean;
    isOptional: boolean;

    constructor(brokerKeys: BrokerField[]) {
        brokerKeys.forEach(broker => {
            switch (broker.Key) {
                case BrokerSettingKeyType.Name:
                    this.name = broker.Value;
                    break;
                case BrokerSettingKeyType.FieldType:
                    this.type = broker.Value;
                    break;
                case BrokerSettingKeyType.IsPassword:
                    this.isPassword = broker.Value;
                    break;
                case BrokerSettingKeyType.IsOptional:
                    this.isOptional = broker.Value;
                    break;
                default:
                    break;
            }
        })
    }
}

export class BrokerSettings {
    brokerKeys = new Map<string, ParsedBrokerField[]>();

    constructor(settings: BrokerSettingsFields[]) {
        settings.forEach((broker) => {
            this.brokerKeys.set(broker.Key, broker.Value.map(keys => new ParsedBrokerField(keys)));
        })
    }
}